import {useSelector} from "react-redux";
import {Outlet} from "react-router-dom";
import Login from "../pages/login";

export default function AllMemberArea(){
    const {user} = useSelector((state)=>({...state}));
    return user ? <Outlet/> : <Login/>;
}